module.exports = __webpack_public_path__ + "img/compromiso.52008261.jpg";